import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';

@Injectable()
export class InformationBarActions implements IInformationBarActions {

  static UPDATE = '[Information Bar] UPDATE';
  static ADD = '[Information Bar] ADD';

  public Add(customPropertiesInformationBar: ICustomPropertiesInformationBar): any {
    return {
      type:  InformationBarActions.ADD,
      payload: customPropertiesInformationBar
    };
  }

}
